// Resolucion de assets por idioma.
//
// Los textos viven en public/locales/<lng>/translation.json, pero hay piezas que
// no son texto: imagenes con tipografia incrustada y las fichas tecnicas en PDF.
// Esas se eligen a partir de t("idioma").
//
// La regla es que un idioma sin arte propia reutiliza la de otro en vez de romper.
// Antes esto se resolvia con cadenas de ternarios cuyo ultimo `else` era japones,
// asi que cualquier idioma nuevo heredaba las piezas en japones sin darse cuenta.

const SUFIJO_POR_DEFECTO = "eng";
const CARPETA_POR_DEFECTO = "ENG";

// Sufijo del nombre de archivo de las imagenes (ej: ranking-xl-esp.png).
// POR todavia no tiene arte propia y usa la española: son las 8 imagenes de
// Vertical, Berlin e International. Al recibir las versiones en portugues,
// agregarlas como *-por.* y cambiar este valor a "por".
const SUFIJOS_ASSET = {
  ENG: "eng",
  CHI: "chi",
  ESP: "esp",
  JAP: "jap",
  POR: "esp",
};

// Carpeta de las fichas tecnicas en public/tf/<CARPETA>/<anio>_sena.pdf.
// POR todavia no tiene sus 32 PDFs y usa los de ESP. Al recibirlos, crear
// public/tf/POR/ y cambiar este valor a "POR".
const CARPETAS_FICHA = {
  ENG: "ENG",
  CHI: "CHI",
  ESP: "ESP",
  JAP: "JAP",
  POR: "ESP",
};

// Un idioma no listado cae en ingles en vez de heredar la pieza de otro idioma.
export const sufijoAsset = (idioma) =>
  SUFIJOS_ASSET[idioma] || SUFIJO_POR_DEFECTO;

export const carpetaFicha = (idioma) =>
  CARPETAS_FICHA[idioma] || CARPETA_POR_DEFECTO;

// Politica de sostenibilidad: public/pdf/sustainability_<sufijo>.pdf.
// Solo existe en ingles y español. POR usa el español; los idiomas sin PDF
// devuelven null y el footer esconde el link, que es como venia funcionando.
const PDF_SOSTENIBILIDAD = {
  ENG: "en",
  ESP: "es",
  POR: "es",
};

export const pdfSostenibilidad = (idioma) =>
  PDF_SOSTENIBILIDAD[idioma] || null;
